import {ClickOutside} from "./ClickOutsideClass";

export class ShowHide {
    trigger: HTMLElement;
    target: HTMLElement;
    triggerClass: string;
    targetClass: string;
    maxHeight: boolean;

    isActive: boolean;

    constructor(trigger: HTMLElement, target: HTMLElement, clickOutside: boolean = false, maxHeight: boolean = false, triggerEvents: boolean = true, triggerClass: string = 'is-active', targetClass: string = 'is-visible') {
        this.trigger = trigger;
        this.target = target;
        this.triggerClass = triggerClass;
        this.targetClass = targetClass;
        this.maxHeight = maxHeight;
        if (clickOutside) {
            ClickOutside.addClickOutside([this.trigger, this.target], () => {
                this.hide();
            });
        }
        this.isActive = this.trigger.classList.contains(this.triggerClass);
        if (triggerEvents) {
          this.addTriggerEvents();
        }
    }

    addTriggerEvents() {
        this.trigger.addEventListener('click', (e) => {
            e.preventDefault();
            if (this.trigger.classList.contains(this.triggerClass)) {
                this.hide();
            }
            else {
                this.show();
            }
        });
    }

    show() {
        this.trigger.classList.add(this.triggerClass);
        this.target.classList.add(this.targetClass);
        if (this.maxHeight) {
            this.target.style.maxHeight = this.target.scrollHeight + "px";
        }
        this.isActive = true;
    }

    hide() {
        this.trigger.classList.remove(this.triggerClass);
        this.target.classList.remove(this.targetClass);
        if (this.maxHeight) {
            this.target.style.maxHeight = null;
        }
        this.isActive = false;
    }

}
